import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { setOrderLimitsFormSchema } from './set-order-limits-form.schema';
import { useEffect } from 'react';

export const useSetOrderLimitsForm = selectedEvent => {
  const form = useForm({
    resolver: yupResolver(setOrderLimitsFormSchema),
    defaultValues: setOrderLimitsFormSchema.cast(selectedEvent ?? {}),
  });

  const { reset } = form;
  useEffect(() => {
    reset(selectedEvent ?? {});
  }, [reset, selectedEvent]);

  return { form };
};
